export function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-inner">
        <a href="/" className="legal-back">← Back to Home</a>
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: April 2026</p>

        <h2>1. Who We Are</h2>
        <p>
          Banoffee ("we", "us", "our") is an AI automation agency. This policy explains how we collect,
          use, and protect your personal data when you visit <strong>banoffee.work</strong> or engage our services.
        </p>
        <p>Contact: <a href="mailto:hello@banoffee.work">hello@banoffee.work</a></p>

        <h2>2. Data We Collect</h2>
        <h3>2a. Website Visitors</h3>
        <ul>
          <li><strong>Contact form submissions:</strong> Name, email address, message content</li>
          <li><strong>Analytics:</strong> Page views, referrer, browser/device type (via Cloudflare Web Analytics — no cookies, no personal identifiers)</li>
          <li><strong>Calendly bookings:</strong> Name, email, and any info you provide during booking (processed by Calendly Inc.)</li>
        </ul>

        <h3>2b. Clients</h3>
        <ul>
          <li>Business contact information</li>
          <li>Project-related data shared under NDA/contract</li>
          <li>Billing information (processed by our payment provider)</li>
        </ul>

        <h2>3. How We Use Your Data</h2>
        <ul>
          <li>To respond to enquiries and schedule calls</li>
          <li>To deliver contracted services</li>
          <li>To improve our website (aggregated, anonymised analytics only)</li>
          <li>To send project updates (never unsolicited marketing without consent)</li>
        </ul>

        <h2>4. Legal Basis (GDPR)</h2>
        <ul>
          <li><strong>Consent:</strong> When you submit a form or book a call</li>
          <li><strong>Legitimate interest:</strong> Analytics for website improvement</li>
          <li><strong>Contract:</strong> When delivering services you've purchased</li>
        </ul>

        <h2>5. Data Sharing</h2>
        <p>We do not sell your data. We share data only with:</p>
        <ul>
          <li><strong>Calendly</strong> — for scheduling (their <a href="https://calendly.com/privacy" target="_blank" rel="noopener">privacy policy</a>)</li>
          <li><strong>Cloudflare</strong> — for hosting and analytics (privacy-first, no tracking cookies)</li>
          <li><strong>Formspree</strong> — for form processing (if contact form is used)</li>
        </ul>

        <h2>6. Data Retention</h2>
        <ul>
          <li>Contact form data: Deleted within 12 months of last interaction</li>
          <li>Client project data: Retained for duration of contract + 2 years (or as legally required)</li>
          <li>Analytics: Aggregated, no personal data retained</li>
        </ul>

        <h2>7. Your Rights</h2>
        <p>Under GDPR and India's DPDP Act 2023, you have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion ("right to be forgotten")</li>
          <li>Withdraw consent at any time</li>
          <li>Data portability</li>
          <li>Lodge a complaint with your local data protection authority</li>
        </ul>
        <p>To exercise any right, email <a href="mailto:hello@banoffee.work">hello@banoffee.work</a>. We'll respond within 30 days.</p>

        <h2>8. Cookies</h2>
        <p>
          This website does <strong>not</strong> use tracking cookies. Cloudflare Web Analytics is
          cookie-free and privacy-first. No cookie consent banner is needed.
        </p>

        <h2>9. Security</h2>
        <p>
          All data is transmitted over HTTPS (TLS 1.2+). We use Cloudflare's DDoS protection,
          WAF, and bot mitigation. Client data is handled under NDA with access limited to project team members.
        </p>

        <h2>10. Children</h2>
        <p>Our services are not directed at individuals under 18. We do not knowingly collect data from minors.</p>

        <h2>11. Changes</h2>
        <p>We may update this policy periodically. Material changes will be noted with a new "Last updated" date at the top.</p>

        <h2>12. Grievance Officer (India)</h2>
        <p>
          In accordance with the Information Technology Act, 2000 and DPDP Act, 2023:<br/>
          Grievance Officer: Pushkar Saxena<br/>
          Email: <a href="mailto:hello@banoffee.work">hello@banoffee.work</a><br/>
          Response time: Within 30 days of receipt
        </p>
      </div>
    </div>
  )
}
